// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Third Party
import moment from 'moment';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
import { Helpers } from '../../shared/services/helpers';
import { FeatureFlagService } from '../../shared/services/featureFlagService';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';
import { exportCsvDTO } from '../../shared/library/export';

//Classes
import { FormAction } from "../../shared/classes/formAction";


//Config/Globals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PracticesViewComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    selector:'practices-viewV2',
    template : '<div class="pv-main-div" data-test-id="content_practices_view">\n\n    <!--=========================================================================================-->\n    <!--Upper Content Area-->\n    <!--=========================================================================================-->\n    <div class="pv-upper-div">\n\n        <!--Title-->\n        <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n        <!--=========================================================================================-->\n        <!--508 Shortcut Block-->\n        <!--=========================================================================================-->\n        <!--Shortcut Keys-->\n        <!--style="border:solid 2px blue; min-height:50px;"-->\n        <!--<div class="off-screen" aria-label="Shortcut Instructions">\n            <div *ngFor="let shortcut of _508_Shortcuts">\n                <span>{{shortcut.item}}:</span><span>{{shortcut.hotkey}}</span>\n            </div>\n        </div>-->\n\n\n        <div style="margin:0 10px 10px 20px; font-style:italic">Select an asset to examine or modify. Note that records are ended when there is a date in the End Date column, and that date has passed. Ended records cannot be modified or viewed.</div>\n\n        <!--Data Controls-->\n        <div class="pv-control-div" role="radiogroup" aria-labelledby="divRadioLabel">\n\n            <div id="divRadioLabel">Filter By:</div>\n\n            <!--ALL-->\n            <div class="pv-filter-radio" (click)="_practiceFilterUpdated(\'all\')" (keyEnter)="_practiceFilterUpdated(\'all\')">\n                <input tabindex="0" id="rdoShowAll" type="radio" value="all" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowAll" class="cpd-focusable">All</label>\n            </div>\n\n            <!--ACTIVE-->\n            <div class="pv-filter-radio" (click)="_practiceFilterUpdated(\'active\')" (keyEnter)="_practiceFilterUpdated(\'active\')">\n                <input tabindex="0" id="rdoShowActive" type="radio" value="active" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowActive" class="cpd-focusable">Active</label>\n            </div>\n\n            <!--ARCHIVED-->\n            <div class="pv-filter-radio" (click)="_practiceFilterUpdated(\'archived\')" (keyEnter)="_practiceFilterUpdated(\'archived\')">\n                <input tabindex="0" id="rdoShowArchived" type="radio" value="archived" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowArchived" class="cpd-focusable">Archived</label>\n            </div>\n\n            <!--ENDED-->\n            <div class="pv-filter-radio" (click)="_practiceFilterUpdated(\'deleted\')" (keyEnter)="_practiceFilterUpdated(\'deleted\')">\n                <input tabindex="0" id="rdoShowDeleted" type="radio" value="deleted" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowDeleted" class="cpd-focusable">Ended</label>\n            </div>\n\n            <!--NATIONAL ONLY FILTERS-->\n            <!--PUBLISHED-->\n            <div *ngIf="_authToken.IsNational();" class="pv-filter-radio" (click)="_practiceFilterUpdated(\'published\')" (keyEnter)="_practiceFilterUpdated(\'published\')">\n                <input tabindex="0" id="rdoShowPublished" type="radio" value="published" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowPublished" class="cpd-focusable">Published</label>\n            </div>\n\n            <!--UN-PUBLISHED-->\n            <div *ngIf="_authToken.IsNational();" class="pv-filter-radio" (click)="_practiceFilterUpdated(\'unpublished\')" (keyEnter)="_practiceFilterUpdated(\'unpublished\')">\n                <input tabindex="0" id="rdoShowUnPublished" type="radio" value="unpublished" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowUnPublished" class="cpd-focusable">Un-Published</label>\n            </div>\n\n            <div style="min-width:10px; min-height:20px; border-left:solid 1px #999; margin-left:10px;"></div>\n\n            <!--ASSET TYPE FILTER-->\n            <div>\n                <label for="selAssetTypeFilter" aria-label="Asset Type Filter" title="Asset Type Filter">Asset Type:</label>\n                <select id="selAssetTypeFilter" [(ngModel)]="_selectedAssetTypeFilter" (change)="assetFilterChanged($event)">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n\n        </div>\n\n    </div>\n\n    <!--=========================================================================================-->\n    <!--Lower Content Area-->\n    <!--=========================================================================================-->\n    <div class="pv-lower-div">\n\n        <!--Practices Grid-->\n        <cas-grid #practicesGrid\n                  summary="{{_title}}"\n                  [settings]="_gridSettings"\n                  (onRefreshClicked)="gridRefreshClicked()"\n                  (onSearch)="onGridSearch($event)">\n        </cas-grid>\n    </div>\n\n    <!-- Popups -->\n    <!--=========================================================================================-->\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="practice_view_v2_page_popups"></div>\n\n    <!--====================-->\n    <!--National Details-->\n    <!--====================-->\n    <modal #nationalDetailsPopup\n           containerId="practice_view_v2_page_popups"\n           title="National Details"\n           label="nationalDetailsPopup">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_practices_view_national_details"></section>\n\n        <!-- body -->\n        <section>\n\n            <div class="cpd-ui-row">\n                <div class="cpd-ui-cell" style="width:100%">\n\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5"><h3>Asset</h3></div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:75px; text-align:right; padding-top:5px">Name:</label><span class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.practice_name}}</span>\n                    </div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:75px; text-align:right;">Short&nbsp;Name:</label><span class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.practice_display}}</span>\n                    </div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:75px; text-align:right;">Shape:</label><span class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.shape_type}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <div style="height:5px;"></div>\n\n            <div class="cpd-ui-row">\n                <div class="cpd-ui-cell" style="width:100%">\n\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5"><h3>States Adopted</h3></div>\n\n                    <!--State records found for this practice-->\n                    <div *ngIf="_nationalDetailsPopup.list.length > 0" class="cpd-ui-field-div" style="padding-top:5px">\n                        <label for="nationalDetailsPopupStateDropdown">State:</label>\n                        <select id="nationalDetailsPopupStateDropdown" [(ngModel)]="_nationalDetailsPopup.selected">\n                            <option *ngFor="let item of _nationalDetailsPopup.list" [ngValue]="item">{{item.state_name}}</option>\n                        </select>\n                    </div>\n\n                    <!--State records NOT found for this practice-->\n                    <div *ngIf="_nationalDetailsPopup.list.length == 0" class="cpd-ui-field-div" style="margin-left:10px; padding-top:5px">\n                        No states have selected this asset for use.\n                    </div>\n\n                </div>\n            </div>\n\n            <div style="height:5px;"></div>\n\n            <div class="cpd-ui-row">\n                <div class="cpd-ui-cell" style="width:100%">\n\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5"><h3>Lifespan Years</h3></div>\n\n                    <div class="cpd-ui-field-div" *ngIf="_nationalDetailsPopup.selected !== null" style="padding-top:5px">\n                        <label for="national_details_state_lifespan" style="width:115px; text-align:right;">State Lifespan:</label>\n                        <input id="national_details_state_lifespan"\n                               [(ngModel)]="_nationalDetailsPopup.selected.state_practice_lifespan_years"\n                               (ngModelChange)="_nationalDetailsPopupChanged()"\n                               type="number" style="width:75px;" name="state_lifespan" />\n                    </div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:115px; text-align:right;">National&nbsp;Lifespan:</label>\n                        <span class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.installed_practice_lifespan_years}}</span>\n                    </div>\n                </div>\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <!--<button type="button" [attr.disabled]="IsNarrativeEndingPopupValid() ? null : \'disabled\'" class="btn btn-primary" (click)="EndNarrative();narrativesEndingPopup.Close();">Save</button>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>-->\n\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" accesskey="s" *ngIf="this._nationalDetailsPopupDirty && _nationalDetailsPopup.selected !== null" aria-label="save" (click)="_UpdateNationalDetails();"><u>S</u>ave</button>\n            <button type="button" class="btn btn-outline-primary" accesskey="s" *ngIf="!this._nationalDetailsPopupDirty || _nationalDetailsPopup.selected === null" aria-disabled="true" aria-label="save" onclick="return false"><u>S</u>ave</button>\n\n        </footer>\n    </modal>\n\n\n    <!--====================-->\n    <!--State Details-->\n    <!--====================-->\n    <modal #stateDetailsPopup\n           containerId="practice_view_v2_page_popups"\n           title="State Details"\n           label="stateDetailsPopup">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_practices_view_state_details"></section>\n\n        <!-- body -->\n        <section>\n\n            <div style="position:relative; top:-10px;"><span style="color:red;">*</span> indicates a required field</div>\n\n            <div class="cpd-ui-row">\n                <div class="cpd-ui-cell" style="width:100%">\n\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5"><h3>Asset</h3></div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:95px; text-align:right;">Name:</label><span class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.practice_display}}</span>\n                    </div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:95px; text-align:right;">Code:</label><span class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.practice_code}}</span>\n                    </div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:95px; text-align:right;">State&nbsp;Lifespan:</label><span id="state_lifespan" class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.state_practice_lifespan_years}}</span>\n                    </div>\n\n                    <div class="cpd-ui-field-div">\n                        <label style="width:95px; text-align:right;">National&nbsp;Lifespan:</label><span id="national_lifespan" class="cpd-demp-txt">{{practicesGrid.GetFirstSelectedRow()?.installed_practice_lifespan_years}}</span>\n                    </div>\n\n                </div>\n            </div>\n            <div class="cpd-ui-row">\n                <div class="cpd-ui-cell" style="width:100%">\n\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5"><h3>Dates</h3></div>\n\n                    <!--start_date-->\n                    <div class="cpd-ui-field-div">\n                        <label for="start_date" style="width:100px; text-align:right;">Start Date<span class="cpd-required" aria-label="required">*</span></label>\n                        <div class="cpd-ui-field-div">\n                            <!--_minDate="{{_now ? _now.format(\'M/D/YYYY\') : \'1/1/1980\'}}"-->\n                            <input type="date"\n                                   [min]="_today"\n                                   placeholder="m/d/yyyy"\n                                   field-validation #fv_pop_sd_start_date=fieldValidation\n                                   [required]="true"\n                                   id="start_date" name="start_date"\n                                   style="width:140px;"\n                                   aria-label="Start date (format m/d/yyyy)"\n                                   title="m/d/yyyy"\n                                   class="form-control"\n                                   [attr.data-first-focus]="true"\n                                   [ngModel]="_stateDetailsPopup.detail?.start_date"\n                                   (ngModelChange)="_stateDetailsPopup.detail.start_date=$event; _stateDetailsPopupChanged()" />\n\n                        </div>\n                    </div>\n\n                    <!--start_date:validation-->\n                    <div *ngIf="!fv_pop_sd_start_date.isValid && fv_pop_sd_start_date.isDirty" style="margin-left:85px;">\n                        <div *ngIf="fv_pop_sd_start_date.errors.required" class="cpd-invalid-field">\n                            <div class="mdi mdi-alert-circle cpd-alert-icon"></div>Start Date is required\n                        </div>\n                        <!--minDate-->\n                        <div *ngIf="fv_pop_sd_start_date.errors.dateBeforeMin" class="cpd-invalid-field">\n                            <div class="mdi mdi-alert-circle cpd-alert-icon"></div>Date must be on or after: {{_now.format("M/D/YYYY")}}\n                        </div>\n                        <!--invalidDate-->\n                        <div *ngIf="fv_pop_sd_start_date.errors.invalidDate" class="cpd-invalid-field">\n                            <div class="mdi mdi-alert-circle cpd-alert-icon"></div>Invalid date\n                        </div>\n                    </div>\n\n\n                    <!--end date-->\n                    <div class="cpd-ui-field-div">\n                        <label for="end_date" style="width:100px; text-align:right;">End Date</label>\n                        <div class="cpd-ui-field-div">\n\n                            <!--*ngIf="_stateDetailsPopup.detail"-->\n                            <input type="date"\n                                   [min]="_today"\n                                   placeholder="m/d/yyyy"\n                                   field-validation #fv_pop_sd_end_date=fieldValidation\n                                   id="end_date" name="end_date"\n                                   style="width:140px;"\n                                   aria-label="End date (format m/d/yyyy)"\n                                   class="form-control"\n                                   title="m/d/yyyy"\n                                   [ngModel]="_stateDetailsPopup.detail?.end_date"\n                                   (ngModelChange)="_stateDetailsPopup.detail.end_date=$event; _stateDetailsPopupChanged();" />\n\n                        </div>\n                    </div>\n\n                    <!--start_date:validation-->\n                    <div *ngIf="!fv_pop_sd_end_date.isValid && fv_pop_sd_end_date.isDirty" style="margin-left:85px;">\n                        <div *ngIf="fv_pop_sd_end_date.errors.required" class="cpd-invalid-field">\n                            <div class="mdi mdi-alert-circle cpd-alert-icon"></div>Start Date is required\n                        </div>\n                        <!--minDate-->\n                        <div *ngIf="fv_pop_sd_end_date.errors.dateBeforeMin" class="cpd-invalid-field">\n                            <div class="mdi mdi-alert-circle cpd-alert-icon"></div>Date must be on or after: {{_now.format("M/D/YYYY")}}\n                        </div>\n                        <!--invalidDate-->\n                        <div *ngIf="fv_pop_sd_end_date.errors.invalidDate" class="cpd-invalid-field">\n                            <div class="mdi mdi-alert-circle cpd-alert-icon"></div>Invalid date\n                        </div>\n                    </div>\n\n\n                </div>\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <!--<button type="button" [attr.disabled]="IsNarrativeEndingPopupValid() ? null : \'disabled\'" class="btn btn-primary" (click)="EndNarrative();stateDetailsPopup.Close();">Save</button>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>-->\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" accesskey="s" [disabled]="!_stateDetailsPopupDirty || !_stateDetailsPopupIsValid()" (click)="_UpdateStateDetails();"><u>S</u>ave</button>\n\n        </footer>\n    </modal>\n\n\n    <!--====================-->\n    <!-- Export All Assets -->\n    <!--====================-->\n    <modal #popExportAllAssets\n           containerId="practice_view_v2_page_popups"\n           title="Export All Assets"\n           label="popExportAllAssets">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="content_practices_view_export_all_assets"></section>\n\n        <!--BODY-->\n        <section>\n\n            <!--ASSET TYPE DDL-->\n            <div class="cpd-control-unit">\n                <label for="selExportAll_assetType" aria-label="Asset Type Filter" title="Asset Type Filter" style="width:90px;">Asset Type:</label>\n                <select id="selExportAll_assetType" [(ngModel)]="_popExportAll_selectedAssetTypeFilter">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n\n        </section>\n\n        <!--FOOTER-->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="exportAllAssets()">Export</button>\n        </footer>\n\n\n    </modal>\n\n    <!--====================-->\n    <!-- Export Assets & Narratives-->\n    <!--====================-->\n    <modal #popExportAssetsAndNarratives\n           containerId="practice_view_v2_page_popups"\n           title="Export Assets And Narratives"\n           label="popExportAssetsAndNarratives">\n\n        <!--FVT-ID-->\n        <section name="Assets_Nar_id" style="visibility:hidden;" data-test-id="content_practices_view_export_assets_and_narratives"></section>\n\n        <!--BODY-->\n        <section>\n\n            <!--ASSET TYPE DDL-->\n            <div class="cpd-control-unit">\n                <label for="selExportAssetsAndNarratives_assetType" aria-label="Asset Type Filter" title="Asset Type Filter" style="width:90px;">Asset Type:</label>\n                <select id="selExportAssetsAndNarratives_assetType" [(ngModel)]="_popExportAssetsAndNarratives_selectedAssetTypeFilter">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n\n        </section>\n\n        <!--FOOTER-->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button id="ANExpBtn" type="button" class="btn btn-primary" data-dismiss="modal" (click)="exportAssetsAndNarratives()">Export</button>\n        </footer>\n\n\n    </modal>\n\n    <!--====================-->\n    <!-- Export Asset Adopted States-->\n    <!--====================-->\n    <modal #popExportAssetAdoptedStates\n           containerId="practice_view_v2_page_popups"\n           title="Export Asset Adopted States"\n           label="popExportAssetAdoptedStates">\n\n        <!--FVT-ID-->\n        <section name="Assets_State_id" style="visibility:hidden;" data-test-id="content_practices_view_export_asset_adopted_states"></section>\n\n        <!--BODY-->\n        <section>\n\n            <div style="position: relative; top: -8px; left: 5px; font-style: italic;">Filter by either Asset Code or State</div>\n\n            <!--ASSET CODE-->\n            <div class="cpd-control-unit">\n                <label for="txtExportAssetAdoptedStates_assetCode" aria-label="Asset Code Filter" title="Asset Code Filter" style="width:90px;">Asset Code:</label>\n                <input id="txtExportAssetAdoptedStates_assetCode"\n                       name="practice_code"\n                       type="text"\n                       style="width:75px;"\n                       [attr.maxLength]="10"\n                       [(ngModel)]="_popExportAssetAdoptedStates_assetCodeFilter" />\n            </div>\n\n            <!--STATE DDL-->\n            <div class="cpd-control-unit">\n                <label for="selExportAssetAdoptedStates_state" aria-label="State Filter" title="State Filter" style="width:90px; padding-top:5px;">State:</label>\n                <select id="selExportAssetAdoptedStates_state" [(ngModel)]="_popExportAssetAdoptedStates_selectedStateFilter">\n                    <option *ngFor="let state of _allStates;" [ngValue]="state">{{state.state_name_display}}</option>\n                </select>\n            </div>\n\n            <div style="position: relative; top: -8px; left: 5px; padding-top: 20px; font-style: italic;">Optional Filter</div>\n\n            <!--ASSET TYPE DDL-->\n            <div class="cpd-control-unit">\n                <label for="selExportAssetAdoptedStates_assetType" aria-label="Asset Type Filter" title="Asset Type Filter" style="width:90px;">Asset Type:</label>\n                <select id="selExportAssetAdoptedStates_assetType" [(ngModel)]="_popExportAssetAdoptedStates_selectedAssetTypeFilter">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n\n        </section>\n\n        <!--FOOTER-->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button id="AASExpBtn" type="button" class="btn btn-primary" (click)="exportAssetAdoptedStates()">Export</button>\n        </footer>\n\n\n    </modal>\n\n    <!--====================-->\n    <!-- Export Asset Adopted & Authorized States-->\n    <!--====================-->\n    <modal #popExportAssetAdoptedAuthorizedStates\n           containerId="practice_view_v2_page_popups"\n           title="Export Asset Adopted & Authorized States"\n           label="popExportAssetAdoptedAuthorizedStates">\n\n        <!--FVT-ID-->\n        <section name="Assets_State_id" style="visibility:hidden;" data-test-id="content_practices_view_export_asset_adopted_authorized_states"></section>\n\n        <!--BODY-->\n        <section>\n\n            <div style="position: relative; top: -8px; left: 5px; font-style: italic;">Filter by Asset Type</div>\n\n            <!--ASSET TYPE DDL-->\n            <div class="cpd-control-unit">\n                <label for="selExportAssetAdoptedAuthorizedStates_assetType" aria-label="Asset Type Filter" title="Asset Type Filter" style="width:90px;">Asset Type:</label>\n                <select id="selExportAssetAdoptedAuthorizedStates_assetType" [(ngModel)]="_popExportAssetAdoptedAuthorizedStates_selectedAssetTypeFilter">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n\n        </section>\n\n        <!--FOOTER-->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button id="AAASExpBtn" type="button" class="btn btn-primary" (click)="exportAssetAdoptedAuthorizedStates()">Export</button>\n        </footer>\n\n\n    </modal>\n\n</div>\n\n\n',
    styles : ['.pv-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.pv-upper-div{flex-grow:0}.pv-control-div{display:flex;align-items:center;margin:20px 0 10px 0;padding-left:20px;font-size:12px}.pv-filter-radio{padding-left:10px;display:flex;align-items:center}.pv-lower-div{position:relative;flex-grow:1;border-top:solid 1px #ccc}.pv-practicesGrid-grid{border-top:solid 1px #b8b8b8}.pv-practicesGrid-columnHeaderRow{background-color:#f0f0f0 !important}'],
    providers:[ ],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class PracticesViewComponentV2 implements OnDestroy, OnInit {

    
    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('practicesGrid') practicesGrid; 
    @ViewChild('nationalDetailsPopup') nationalDetailsPopup;
    @ViewChild('stateDetailsPopup') stateDetailsPopup;
    @ViewChild('popExportAllAssets') popExportAllAssets;
    @ViewChild('popExportAssetsAndNarratives') popExportAssetsAndNarratives;
    @ViewChild('popExportAssetAdoptedStates') popExportAssetAdoptedStates;
    @ViewChild('popExportAssetAdoptedAuthorizedStates') popExportAssetAdoptedAuthorizedStates;
    @ViewChild('fv_pop_sd_start_date') fv_pop_sd_start_date;
    @ViewChild('fv_pop_sd_end_date') fv_pop_sd_end_date;

    //Class wide member reference for the growls control
    growlBox = null;          


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _508_Shortcuts = []; //Obj Array { item:<str>, hotkey:<str> }

    _authToken = authToken; //Needed to use authToken on the template
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _from = null; //Holds the "from" query parameter if provided (if from==1 then this page was loaded from the initial login)

    //_fields_hash = [];
    //_formName = 'practices_view'; //Just a shortcut (also helpful for cut & paste)
    _componentName = 'practicesView.js';
    _forms = []; //Contains the form info and form fields associated with this view

    _nationalDetailsPopup = { selected : null, list : [] };
    _selectedPracticeFilter = "all";
    _stateDetailsPopup = { detail : null };
    _stateDetailsPopupDirty = false;
    _nationalDetailsPopupDirty = false;

    _assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code:"" }];
    _selectedAssetTypeFilter = this._assetTypeFilters[0];
    _popExportAll_selectedAssetTypeFilter;
    _popExportAssetsAndNarratives_selectedAssetTypeFilter;
    _popExportAssetAdoptedStates_selectedAssetTypeFilter;
    _popExportAssetAdoptedStates_assetCodeFilter = "";
    _popExportAssetAdoptedStates_selectedStateFilter = null;
    _popExportAssetAdoptedAuthorizedStates_selectedAssetTypeFilter;
    _allStates = [];

    _now = moment();//today
    _today = new Date().toISOString().substring(0, 10);

    _title = "";

    _gridSettings = {
        gridId:"mainPracticeGrid",
        //cssClasses_Grid:"pv-practicesGrid-grid",
        hideClearSelectedButton:true,
        hideSearchBox:false,
        loading:true,
        positionAbsolute:true,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"practice_code",
        rowIdentityPrefixForJAWS:"Asset Code",
        showCheckboxColumn:true,
        columns:[
            { fieldName: 'practice_code', display:'Code', width:'8%', minWidth:25 },
            { fieldName: 'replacement_code', display:'Replacement', width:'8%', minWidth:25 },
            { fieldName: 'practice_type_code', display: 'Asset Type', width: '8%', minWidth: 25, toolTipFn: (cellValue, row) => { return row.practice_type_code_display; } },
            { fieldName: 'practice_name', display:'Asset', width:'25%', minWidth:100 },
            { fieldName: 'measurement_unit_display', display:'Units', width:'5%', minWidth:20 },
            //{ fieldName: 'shape_type', display:'Shape', width:'8%', minWidth:25 },
            { fieldName: 'status', display:'Status', width:'8%', minWidth:50 },
            { fieldName: 'start_date', display: 'Effective', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },  //shortcut for: procDataFn:(startDate) => { return this._formatDate(startDate); } },
            { fieldName: 'sunset_date', display: 'Sunset Date', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },      //shortcut for: procDataFn:(endDate) => { return this._formatDate(endDate); } },
            { fieldName: 'end_date', display: 'End Date', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },      //shortcut for: procDataFn:(endDate) => { return this._formatDate(endDate); } },

        ],
        rows:[]
    };

    _gridSettingsState = {
        gridId: "mainPracticeGrid",
        //cssClasses_Grid:"pv-practicesGrid-grid",
        hideClearSelectedButton: true,
        hideSearchBox: false,
        loading: true,
        positionAbsolute: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "practice_code",
        rowIdentityPrefixForJAWS: "Asset Code",
        showCheckboxColumn: true,
        columns: [
            { fieldName: 'practice_code', display: 'Code', width: '8%', minWidth: 25 },
            { fieldName: 'replacement_code', display: 'Replacement', width: '8%', minWidth: 25 },
            { fieldName: 'practice_type_code', display: 'Asset Type', width: '6%', minWidth: 20, toolTipFn: (cellValue, row) => { return row.practice_type_code_display; } },
            { fieldName: 'practice_name', display: 'Asset', width: '25%', minWidth: 100 },
            { fieldName: 'measurement_unit_display', display: 'Units', width: '5%', minWidth: 20 },
            { fieldName: 'status', display: 'Status', width: '6%', minWidth: 30 },
            { fieldName: 'start_date', display: 'Effective', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },  //shortcut for: procDataFn:(startDate) => { return this._formatDate(startDate); } },
            { fieldName: 'sunset_date', display: 'Sunset Date', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },      //shortcut for: procDataFn:(endDate) => { return this._formatDate(endDate); } },
            { fieldName: 'end_date', display: 'National End Date', width: '9%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },      //shortcut for: procDataFn:(endDate) => { return this._formatDate(endDate); } },
            { fieldName: 'state_end_date', display: 'State End Date', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },      //shortcut for: procDataFn:(endDate) => { return this._formatDate(endDate); } },

        ],
        rows: []
    };

    _pageURL = '';


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(casNavBoxService:CASNavBoxService,
                cpdFormatters: CPDFormatters,
                //ngbDateParser: casNgbDateParserFormatter,
                helpers: Helpers,
                route:ActivatedRoute,
                router:Router,
                webServices: WebServices,
                featureFlagService: FeatureFlagService){

        this.constructor.mapParams(this, arguments);

        this._pageURL = this.router.url;

        // Params
        //--------------------
        //Grab the "from" param if provided to alter the element focus strategy (508)
        this.route.params.subscribe((p)=>{
            this._from = p.from ? p.from : null; //1==default path (i.e. initial load, not from a nav link)
            //console.log("[constructor] = this._from:", this._from);
        });

        // NavBox
        //--------------------
        //Handle clicks on the NavBox actions via the navBoxCommService
        var disposer = casNavBoxService.OnActionClicked$.subscribe( action => { this.navBoxActionClicked(action); });
        this._disposalFunctions.push(disposer);


        // Set title 
        //--------------------
        //(In the future, we probably want to add this to the link between forms & roles in the DB [d_role_form])
        switch(authToken.user.role){

            //State
            case Enums.Roles.StateDataSteward.id:
                this._title = authToken.user.stateName + " - Assets List";
                break;

            default:
                this._title = "National - Assets List";
                break;
        }
        
        // Debugging 
        //--------------
        //casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("Service Test", "Test", "zRoles Test");
        //disposer = casNavBoxService.OnDebugEntryClicked$.subscribe( entry => {
        //    this._debugEntryClicked(entry);
        //});
        //this._disposalFunctions.push(disposer);
    };
    
    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        for (var i=0; i<this._disposalFunctions.length; i++){
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){
        console.log("\n[practicesView:ngOnInit()]------------------------------------------------------------------------");
        
        this.set508();
        this.initalizeGrowlBox();

        //Add Conditional rows to main grid
        if (this._authToken.user.role == Enums.Roles.StateDataSteward.id) {
            this._gridSettings = this._gridSettingsState;
            this._gridSettings.columns.push({ fieldName: 'state_practice_lifespan_years', display: 'Lifespan', width: '8%', minWidth: 60 });
        }
        else{
            this._gridSettings.columns.push({ fieldName:'installed_practice_lifespan_years', display:'Lifespan', width:'8%', minWidth:60 });
        }

        this.performAsyncOperations();
    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {
        this.setNavBoxActions();
        this._markGridAsLoading(false);
        this.casNavBoxService.ActionsLoading = false;
    };

    //==================================
    // initalizeGrowlBox
    //==================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    };

    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action){

        if (!action.__enabled){ return; }
        let selectedRow = this.practicesGrid.GetFirstSelectedRow();

        //Test to see if this action can be used
        // returns { canExecute<bool>, message<string> }
        var res = this._canExecuteAction(action);
        if (!res.canExecute){
            this.growlBox.addGrowl("info", res.message);
            return;
        }

        switch (action.field_name.toLowerCase()){


            // NATIONAL DETAILS
            //--------------------------------------
            case "act_national_details":

                if (selectedRow){

                    this._nationalDetailsPopup = { selected : null, list : [] };
                    this.nationalDetailsPopup.Open(); //todo: Should probably add a loading indicator in case this runs long

                    this.webServices.Get({
                        apiPath: "/practices/getStatePracticeDetails",
                        args: { practiceId: selectedRow.practice_id }
                    })
                    .then(res => {
                        console.log("[{0}:navBoxActionClicked():/practices/getStatePracticeDetails] - res:".format(this._componentName), res);
                        this._nationalDetailsPopup.list = res.data.DTO;
                        if (this._nationalDetailsPopup.list.length > 0) {
                            this._nationalDetailsPopup.selected = this._nationalDetailsPopup.list[0];
                        }
                    })
                    .catch(err => {
                        this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                    });
                }
                break;


            // STATE DETAILS
            //--------------------------------------
            case "act_state_details":
                if (selectedRow){
                    this._stateDetailsPopup = {
                        detail : {
                            start_date: selectedRow.start_date ? new Date(selectedRow.start_date).toISOString().substring(0, 10) : null,
                            end_date: selectedRow.end_date ? new Date(selectedRow.end_date).toISOString().substring(0, 10) : null,
                            practice_state_id: selectedRow.practice_state_id,
                        }
                    };
                    //this.modalService.open( this.stateDetailsPopupTemplate );
                    this._stateDetailsChanged = false;
                    this.fv_pop_sd_start_date.MarkAsClean();
                    this.fv_pop_sd_start_date.Validate();
                    this._stateDetailsPopupDirty = false;
                    this.stateDetailsPopup.Open();

                    //console.log("act_state_details:this._stateDetailsPopup.detail:", this._stateDetailsPopup.detail);
                }
                break;
            
            // NEW PRACTICE
            // NEW STATE PRACTICE
            //--------------------------------------
            case "act_new_practice":
            //case "act_new_state_practice": 8-7-2017: "act_new_state_practice" is hidden in the DB based on UAT comments
                this.router.navigate(["/cpdes/practices/editV2"]);
                break;


            // REVISE PRACTICE
            //-----------------------------------------
            case "act_revise_practice":
                //Make sure a practice is selected
                if (selectedRow){
                    //Navigate to the edit page
                    this.router.navigate(["/cpdes/practices/editV2/" + selectedRow.practice_id]);
                }
                break;


            // VIEW PRACTICE
            //--------------------------------------
            // This is only used for State Stewards. "Revise Practice" is used for National users
            case "act_view_practice":
                this.router.navigate(["/cpdes/practices/editV2/" + selectedRow.practice_id]); //Edit page will disable editing for state
                break;

            // ASSET CHANGE HISTORY
            //--------------------------------------
            case "act_asset_change_history":
                //Make sure a practice is selected
                if (selectedRow) {
                    //Navigate to the history page
                    this.router.navigate(["/cpdes/practices/assetHistory/" + selectedRow.practice_id]);
                }
                break;

            // EXPORT ALL ASSETS
            //--------------------------------------
            case "act_export_all_assets":
                this.openExportAllAssets();
                break;

            // EXPORT ASSETS AND NARRATIVES
            //--------------------------------------
            case "act_export_assets_and_narratives":
                this.openExportAssetsAndNarratives();
                break;

            // EXPORT ASSET ADOPTED STATES
            //--------------------------------------
            case "act_export_asset_adopted_states":
                this.openExportAssetAdoptedStates();
                break;

            // EXPORT ASSET ADOPTED & AUTHORIZED STATES
            //--------------------------------------
            case "act_export_asset_adopted_authorized_states":
                this.openExportAssetAdoptedAuthorizedStates();
                break;

        }

    };

    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // assetFilterChanged
    //==================================
    assetFilterChanged(e) {
        this._loadGrid(true);
    };

    //=======================================
    // exportAssetAdoptedStates
    //=======================================
    exportAssetAdoptedStates() {

        // Validation of filtering by either state or asset code. If asset code, validate that it an existing one
        if (this._popExportAssetAdoptedStates_selectedStateFilter && this._popExportAssetAdoptedStates_selectedStateFilter.state_code == "") { this._popExportAssetAdoptedStates_selectedStateFilter = null; }
        if (this._popExportAssetAdoptedStates_selectedStateFilter) {
            if (this._popExportAssetAdoptedStates_assetCodeFilter != "") {
                this.growlBox.addGrowl("error", "Please select just one filter.");
                return;
            }
        }
        else {
            if (this._popExportAssetAdoptedStates_assetCodeFilter == "") {
                this.growlBox.addGrowl("error", "Please select either Asset Code or State.");
                return;
            }
            else {
                if (this.practicesGrid) {
                    if (this.practicesGrid.viewRows.filter(c => c.practice_code == this._popExportAssetAdoptedStates_assetCodeFilter).length < 1) {
                        this.growlBox.addGrowl("error", "Asset Code does not exist.");
                        return;
                    }
                }
            }
        }

        //console.log(`  [${this._componentName}:exportAssetAdoptedStates()]`)
        this.growlBox.addGrowl("info", "Exporting adopted states...");
        let filterText = this._popExportAssetAdoptedStates_assetCodeFilter ? this._popExportAssetAdoptedStates_assetCodeFilter : this._popExportAssetAdoptedStates_selectedStateFilter.state_name_display.trim();

        this.webServices.Get({
            apiPath: "/practices/exportAssetAdoptedStates",
            args: {
                assetCode: this._popExportAssetAdoptedStates_assetCodeFilter,
                stateCode: !this._popExportAssetAdoptedStates_selectedStateFilter ? "" : this._popExportAssetAdoptedStates_selectedStateFilter.state_code,
                practiceTypeCode: this._popExportAssetAdoptedStates_selectedAssetTypeFilter.practice_type_code
            }
        })
            .then(res => {

                console.log("[{0}:exportAssetAdoptedStates():/practices/exportAssetAdoptedStates] - res:".format(this._componentName), res);

                if (!res.data.DTO || res.data.DTO == "") {
                    this.growlBox.addGrowl("info", "No records found for the indicated search.");
                    return;
                }

                this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

                //Popup in new window
                exportCsvDTO(res.data.DTO, 'Asset-Adopted-States', filterText);
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });

    }

    //=======================================
    // exportAssetAdoptedAuthorizedStates
    //=======================================
    exportAssetAdoptedAuthorizedStates() {

        //console.log(`  [${this._componentName}:exportAssetAdoptedAuthorizedStates()]`)
        this.growlBox.addGrowl("info", "Exporting adopted & authorized states...");

        this.webServices.Get({
            apiPath: "/practices/exportAssetAdoptedAuthorizedStates",
            args: {
                practiceTypeCode: this._popExportAssetAdoptedAuthorizedStates_selectedAssetTypeFilter.practice_type_code
            }
        })
            .then(res => {

                console.log("[{0}:exportAssetAdoptedAuthorizedStates():/practices/exportAssetAdoptedAuthorizedStates] - res:".format(this._componentName), res);

                if (!res.data.DTO || res.data.DTO == "") {
                    this.growlBox.addGrowl("info", "No records found for the indicated search.");
                    return;
                }

                this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

                //Popup in new window
                let filterText = this._popExportAssetAdoptedAuthorizedStates_selectedAssetTypeFilter.practice_type_code_display == "All" ? "All" : this._popExportAssetAdoptedAuthorizedStates_selectedAssetTypeFilter.practice_type_code_display;
                exportCsvDTO(res.data.DTO, 'Asset-Adopted-Authorized-States', filterText);
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });

    }

    //=======================================
    // exportAllAssets
    //=======================================
    exportAllAssets() {

        //console.log(`  [${this._componentName}:exportAllAssets()]`);

        //This is erroneous information since the popup has its own type filter now
        //If you had no records on the table but changed the filter in the popup, it would say no records
        //found, which could be completely wrong.  
        //if (this._gridSettings.rows.length == 0){
        //    this.growlBox.addGrowl("info", "No rows to export");
        //    //this.popExportAllAssets.Close();
        //    return;
        //}

        this.growlBox.addGrowl("info", "Exporting capp...");

        this.webServices.Get({
            apiPath: "/practices/exportAllAssets",
            args: {
                practiceTypeCode: this._popExportAll_selectedAssetTypeFilter.practice_type_code
            }
        })
        .then(res => {

            console.log("[{0}:exportAllAssets():/practices/exportAllAssets] - res:".format(this._componentName), res);

            if (!res.data.DTO || res.data.DTO == ""){
                this.growlBox.addGrowl("info", "No records found for the indicated search.");
                //this.popExportCAAP.Close();
                return;
            }

            this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

            //Popup in new window
            exportCsvDTO(res.data.DTO, 'Asset', this._popExportAll_selectedAssetTypeFilter.practice_type_code_display);
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
        });

    }

    //=======================================
    // exportAssetsAndNarratives
    //=======================================
    exportAssetsAndNarratives() {
        console.log(`  [${this._componentName}:exportAssetsAndNarratives()]`);

        //This is erroneous information since the popup has its own type filter now
        //If you had no records on the table but changed the filter in the popup, it would say no records
        //found, which could be completely wrong.  
        //if (this._gridSettings.rows.length == 0) {
        //    this.growlBox.addGrowl("info", "No rows to export");
        //    //this.popExportAssetsAndNarratives.Close();
        //    return;
        //}

        this.growlBox.addGrowl("info", "Exporting Assets and Narratives");

        this.webServices.Get({
            apiPath: "/practices/exportAssetsAndNarratives",
            args: {
                practiceTypeCode: this._popExportAssetsAndNarratives_selectedAssetTypeFilter.practice_type_code
            }
        })
            .then(res => {

                console.log(`[${this._componentName}:exportAssetsAndNarratives():/practices/exportAssetsAndNarratives] - res:`, res);


                if (!res.data.DTO || res.data.DTO == "") {
                    this.growlBox.addGrowl("info", "No records found for the indicated search.");
                    return;
                }

                this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

                //Popup in new window
                exportCsvDTO(res.data.DTO, 'Asset-Narratives', this._popExportAssetsAndNarratives_selectedAssetTypeFilter.practice_type_code_display);
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "Export Failed");
                console.log("Error: Export Failed. ", this.cpdFormatters.formatError(err));
            });
    }

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked(){
        this._loadGrid(true);
    };

    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText){
        
        //console.log("onGridSearch", event);

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0){
            this.practicesGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.practice_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.practicesGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //=======================================
    // openExportAllAssets
    //=======================================
    openExportAllAssets() {
        //console.log("_popExportAll_selectedAssetTypeFilter:", this._popExportAll_selectedAssetTypeFilter);
        this.popExportAllAssets.Open(() => {
            //Fires when the box is closed
        });
    }

    //=======================================
    // openExportAssetAdoptedStates
    //=======================================
    openExportAssetAdoptedStates() {
        this._popExportAssetAdoptedStates_assetCodeFilter = "";
        this._popExportAssetAdoptedStates_selectedStateFilter = null;
        this._popExportAssetAdoptedStates_selectedAssetTypeFilter = this._assetTypeFilters[0];
        this._loadAllStates();
        this.popExportAssetAdoptedStates.Open(() => {
            //Fires when the box is closed
        });
    }

    //=======================================
    // openExportAssetAdoptedAuthorizedStates
    //=======================================
    openExportAssetAdoptedAuthorizedStates() {
        this._popExportAssetAdoptedAuthorizedStates_selectedAssetTypeFilter = this._assetTypeFilters[0];
        this.popExportAssetAdoptedAuthorizedStates.Open(() => {
            //Fires when the box is closed
        });
    }

    //=======================================
    // openExportAssetsAndNarratives
    //=======================================
    openExportAssetsAndNarratives() {
        this.popExportAssetsAndNarratives.Open(() => {
            //Fires when the box is closed
        });
    }

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations() {
        // Async Operations
        //-------------------
        let ops = 2;

        //LOAD GRID
        this._loadGrid(false, () => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //LOAD ASSET TYPES
        this._loadAssetTypes(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //LOAD FEATURE FLAGS
        //this.casNavBoxService.ActionsLoading = true;
        //this._loadFeatureFlags(() => {
        //    if (--ops == 0) { this.ngOnInit_Complete(); }
        //});
    }

    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            //508 people want a different focus starting point if this is the first page load
            let el = null;
            if (this._from == 1) {
                el = document.getElementById("divSkipNav");
            }
            else {
                //Main content area (title)
                el = document.getElementsByClassName("cpd-title-div")[0];
            }
            if (el) { el.focus(); }

        }, 0);
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        //ACTIONS
        let actions = [];

        switch (this._authToken.user.role) {

            //National Practice Data Steward
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_national_details", "National Details"));
                actions.push(new FormAction("act_new_practice", "New Asset"));
                actions.push(new FormAction("act_revise_practice", "Edit Asset"));
                actions.push(new FormAction("act_export_all_assets", "Export All Assets"));
                actions.push(new FormAction("act_export_assets_and_narratives", "Export Assets & Narratives"));
                actions.push(new FormAction("act_export_asset_adopted_states", "Export Adopted States"));
                actions.push(new FormAction("act_export_asset_adopted_authorized_states", "Export Adopted & Auth States"));
                actions.push(new FormAction("act_asset_change_history", "Asset Change History"));
                break;

            //State Data Steward
            case Enums.Roles.StateDataSteward.id:
                actions.push(new FormAction("act_state_details", "State Details"));
                actions.push(new FormAction("act_view_practice", "View Asset"));
                actions.push(new FormAction("act_export_all_assets", "Export All Assets"));
                actions.push(new FormAction("act_export_assets_and_narratives", "Export Assets & Narratives"));
                break;

            //National Discipline Data Steward
            case Enums.Roles.NationalDisciplineDataSteward.id:
                actions.push(new FormAction("act_view_practice", "View Asset"));
                actions.push(new FormAction("act_export_all_assets", "Export All Assets"));
                actions.push(new FormAction("act_export_assets_and_narratives", "Export Assets & Narratives"));
                actions.push(new FormAction("act_export_asset_adopted_states", "Export Adopted States"));
                actions.push(new FormAction("act_export_asset_adopted_authorized_states", "Export Adopted & Auth States"));
                break;

            //DataViewer
            case Enums.Roles.DataViewer.id:
                actions.push(new FormAction("act_national_details", "National Details"));
                actions.push(new FormAction("act_view_practice", "View Asset"));
                actions.push(new FormAction("act_export_all_assets", "Export All Assets"));
                break;
        }

        //Apply the actions   
        if (this.router.url.startsWith(this._pageURL)) {
            this.casNavBoxService.Actions = actions;
        }
    };


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _canExecuteAction
    //==================================
    // returns { canExecute<bool>, message<string> }
    // Message is populated with the reason why if canExecute = false;
    _canExecuteAction(action){

        let ret = { canExecute:true, message:"" }; 

        //Grab the first selected row (or null if none selected)
        let selectedRow = this.practicesGrid.GetFirstSelectedRow();


        switch (action.field_name){

            case "act_new_practice":
                break;

            case "act_national_details":
            case "act_state_details":
            case "act_revise_practice":
            case "act_view_practice":

                //Row Selected?
                if (!selectedRow){
                    ret.canExecute = false;
                    ret.message = "No row selected";
                    return ret;
                }

                //Row Deleted?
                if (this._isPracticeDeleted(selectedRow)){
                    ret.canExecute = false;
                    ret.message = "Selected row is marked as ended";
                    return ret;
                }
                break;

            case "act_replace_practice":
            case "act_delete_practice":
            case "act_asset_change_history":

                //Any rows selected?
                if (this.practicesGrid.GetSelectedRows().length == 0){
                    ret.canExecute = false;
                    ret.message = "No rows have been selected";
                    return ret;
                }
        }

        return ret;
    };

    //==================================
    // _formatDate
    //==================================
    _formatDate(dateString){
        return this.cpdFormatters.formatDateString(dateString);
    };

    //==================================
    // _formatNationalIndicator
    //==================================
    _formatNationalIndicator(national){
        return national.toUpperCase().trim() == "Y" ? "Y" : "N";
    };

    //==================================
    // _isPracticeDeleted
    //==================================
    // practice.end_date is presumed to be a string representation of a date
    _isPracticeDeleted(practice){
        if (practice === undefined || practice === null){ throw("[practicesView:_isPracticeDeleted()] practice argument required"); }

        //If end date is not set, then this is not a deleted practice
        if (practice.end_date === null || practice.end_date.trim().length < 1){ return false; }

        //If the end date is set but invalid, then consider it not deleted
        var endDate = moment(practice.end_date)
        if (!endDate.isValid()){ return false; }

        //If the end date is in the future, then the practice is not *yet* deleted
        if (endDate.isAfter(new Date())){ return false; }

        return true;
    };


    //==================================
    // _loadAllStates
    //==================================
    _loadAllStates() {

        //Get states list without child states, no longer using EF to grab states here
        this.webServices.Get({ apiPath: "/practices/getAllStatesNoChildren" })
            .then(res => {
                console.log("[practicesView:_loadStates$()] (/practices/getAllStatesNoChildren, Default) res:", res);

                this._allStates = [{ state_name_display: "", state_code: "" }].concat(res.data.DTO);
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });

    };

    //==================================
    // _loadAssetTypes
    //==================================
    _loadAssetTypes(fnOnSuccess, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getPracticeTypeCodes",
            args: {
                fy: null,
                includeAll: false
            }
        })
        .then(res => {
            console.log("[{0}:/practices/getPracticeTypeCodes] - res:".format(this._componentName), res);
            let dto = res.data.DTO;

            //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
            try {

                //Build the asset types list
                this._assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code:"" }].concat(dto);
                this._selectedAssetTypeFilter = this._assetTypeFilters[0];
                this._popExportAll_selectedAssetTypeFilter = this._assetTypeFilters[0];
                this._popExportAssetsAndNarratives_selectedAssetTypeFilter = this._assetTypeFilters[0];
                this._popExportAssetAdoptedStates_selectedAssetTypeFilter = this._assetTypeFilters[0];
                if (fnOnSuccess) { fnOnSuccess(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:_loadAssetTypes()]".format(this._componentName), err);
                if (fnOnError) { fnOnError(); }
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

            //Hide the loading message
            //this._markGridAsLoading(false);

            if (fnOnError) { fnOnError(); }
        });

    }

    //==================================
    // _loadGrid
    //==================================
    // Loads the grid using the current filter
    //  Returns:Promise(recordCount)
    _loadGrid(manageLoadIndicators, fnOnSuccess, fnOnError){

        if (manageLoadIndicators) {
            this._markGridAsLoading(true);
        }

        this.webServices.Get({
            apiPath: "/practices/getPracticesListByRoleV2",
            args: {
                filter: this._selectedPracticeFilter,
                assetTypeCode: this._selectedAssetTypeFilter.practice_type_code
            }
        })
        .then(res => {
            console.log("[{0}:/practices/getPracticesListByRoleV2] - res:".format(this._componentName), res);
            let dto = res.data.DTO;

            //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
            try {

                //Apply new data to the grid
                this._setGridRows(dto);

                //Hide the loading message
                if (manageLoadIndicators) {
                    this._markGridAsLoading(false);
                }

                //Fresh load, go to first page
                this.practicesGrid.GoToFirstPage();

                if (fnOnSuccess) { fnOnSuccess(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:_loadGrid()]".format(this._componentName), err);

                //Always hide the loading message on errors
                this._markGridAsLoading(false);

                if (fnOnError) { fnOnError(); }
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

            //Always hide the loading message on errors
            this._markGridAsLoading(false);

            if (fnOnError) { fnOnError(); }
        });
    };

    //==================================
    // _loadFeatureFlags
    //==================================
    //_loadFeatureFlags(fnOnComplete) {
    //    //Get Feature Flags in bulk        
    //    this.featureFlagService.getFeatureFlags()
    //        .then(res => {

    //            //Grab the ffs
    //            // This feature flag is no longer needed
    //            //this._ff_assetHistory = !!res.find(ff => ff.KeyName == Enums.FeatureFlags.AssetHistory);

    //            if (fnOnComplete) { fnOnComplete(); }

    //            //console.log("=====================================");
    //            //console.log("_ff_assetHistory:", this._ff_assetHistory);
    //            //console.log("=====================================");
    //        })
    //        .catch(err => {
    //            this.growlBox.addGrowl("error", "Feature Flag Load Failed");
    //            console.log(this.cpdFormatters.formatError(err));
    //        });
    //}
    
    //==================================
    // _nationalDetailsPopupChanged
    //==================================
    _nationalDetailsPopupChanged(){
        //Mark form dirty
        if (!this._nationalDetailsPopupDirty){ this._nationalDetailsPopupDirty = true; }
    }

    //==================================
    // _cleanNationalDetailsPopup()
    //==================================
    _cleanNationalDetailsPopup() {
        this._nationalDetailsPopupDirty = false;
    }

    //==================================
    // _practiceFilterUpdated
    //==================================
    _practiceFilterUpdated(filter){

        //jump out for unrecognized filters
        if ("all,active,archived,published,deleted,unpublished,practices,other".indexOf(filter) < 0){
            throw("[practicesView:_practiceFilterUpdated] Unrecognized filter");
        }

        //Set the member value
        this._selectedPracticeFilter = filter;

        //Clear any search box filters
        this.practicesGrid.ClearFilter("search", false);
        this.practicesGrid.ClearSearchBox();

        this._loadGrid(true);
    };

    //==================================
    // _stateDetailsPopupChanged
    //==================================
    _stateDetailsPopupChanged(){
        //Mark form dirty
        if (!this._stateDetailsPopupDirty){ this._stateDetailsPopupDirty = true; }
    }

    //==================================
    // _stateDetailsPopupIsValid
    //==================================
    _stateDetailsPopupIsValid(){

        //Validate
        if (!this.fv_pop_sd_start_date.Validate()){ return false; }
        if (!this.fv_pop_sd_end_date.Validate()){ return false; }

        return true;
    };

    //==================================
    // _UpdateNationalDetails
    //==================================
    _UpdateNationalDetails(){

        //Note, the data being saved is in the pratice state table and is no what is displayed on the grid
        //for the current screen (national).  Therefore, there is no need to refresh the grid.

        //Prep for saving
        this.casNavBoxService.DisableAllLinks();
        this.nationalDetailsPopup.Close();
        this.growlBox.addGrowl("info", "Saving Details...");

        //Execute the save
        this._UpdatePracticeStateDetails(this._nationalDetailsPopup.selected, (res)=>{

            //Clean up
            this.casNavBoxService.EnableAllLinks();
            
            //Jump out if there was a failure
            if (!res.Success) {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                return;
            }

            //Let the user know we're done
            this.growlBox.addGrowl("success", "Details Saved");
            this._cleanNationalDetailsPopup();
        });
    }
    
    //==================================
    // _UpdateStateDetails
    //==================================
    _UpdateStateDetails(){

        //Prep the object to be saved
        //(gotta convert the datepicker object value to something the service can use)
        var statePracticeDetailsDTO = {
            start_date: this._stateDetailsPopup.detail.start_date ? new Date(this._stateDetailsPopup.detail.start_date).toISOString() : null,
            end_date: this._stateDetailsPopup.detail.end_date ? new Date(this._stateDetailsPopup.detail.end_date).toISOString() : null,
            practice_state_id: this._stateDetailsPopup.detail.practice_state_id
        }

        //Prep for saving
        this.casNavBoxService.DisableAllLinks();
        this._markGridAsLoading(true);
        this.stateDetailsPopup.Close();
        this.growlBox.addGrowl("info", "Saving Details...");

        //Execute the save
        this._UpdatePracticeStateDetails(statePracticeDetailsDTO, (res)=>{

            //Clean up
            this.casNavBoxService.EnableAllLinks();
            
            //Jump out if there was a failure
            if (!res.Success) {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                this._markGridAsLoading(false);
                return;
            }

            //Let the user know we're done
            this.growlBox.addGrowl("success", "Details Saved");

            //Refresh the list
            this._loadGrid(true);
        });
    }

    //==================================
    // _UpdatePracticeStateDetails()
    //==================================
    _UpdatePracticeStateDetails(stateDetailsRecord, fnOnComplete){

        this.webServices.Post("/practices/updateStatePracticeDetails", stateDetailsRecord)
            .then(res => {
                console.log("[{0}:_UpdatePracticeStateDetails()] - res:".format(this._componentName), res);
                if (fnOnComplete){ fnOnComplete(res); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this._markGridAsLoading(false);
            })   
    }


    // BOILER PLATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.practicesGrid){
            this.practicesGrid.MarkAsLoading(isLoading);
        }
        else{
            this._gridSettings.loading = isLoading;
        }
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here we'll test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.practicesGrid){
            this.practicesGrid.SetRows(data);
        }
        else{
            this._gridSettings.rows = data;
        }
    }

    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry){
        console.log("[practicesView:_debugEntryClicked]");
        //console.log("    ", entry);

        //switch (entry){

        //    case "Service Test":
        //        this.webServices.GetPracticesListByRole("all")
        //            .then(res => {
        //                console.log("SUCCESS (this.webServices.GetPracticesListByRole('all')):", res);
        //            })
        //            .catch(res => {
        //                console.log("ERROR (this.webServices.GetPracticesListByRole('all')):", "(" + res.status + ")", res.err);
        //            });
        //        break;

        //    case "Test":
        //        this.webServices.GetMyForm("practices_view")
        //            .then(res => {
        //                console.log("SUCCESS (this.webServices.GetMyForm('practices_view')):", res);
        //            })
        //            .catch(res => {
        //                console.log("ERROR (this.webServices.GetMyForm('practices_view')):", "(" + res.status + ")", res.err);
        //            });
        //        break;

        //    case "zRoles Test":
        //        this.webServices.ZRolesTest()
        //        .then((res) => { console.log("[ZRolesTest - res:]", res); })
        //        .catch((err)=>{ console.log("[ZRolesTest - err:]", err); })
        //        break;
        //}

    };

}//component

